import { FC } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';
import { ChevronUpSvg } from './svgs';

export const IconChevronUp: FC<SvgIconProps> = (props) => {
  return <SvgIcon component={ChevronUpSvg} viewBox="0 0 24 24" {...props} />;
};
